<template>
  <div class="action-config-item">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <div>
      <el-button class="email-config-button" @click="openWhatsappConfig()">
        <i style="color: #409eff" class="el-icon-setting">configure whatsapp</i>
      </el-button>
    </div>
    <!-- Footer Actions -->
    <div class="automation-footer-actions mt-4 flex justify-end gap-2">
      <el-button @click="cancelChanges">Cancel</el-button>
      <el-button type="primary" @click="saveChanges">Save</el-button>
    </div>
    <dialog-component
      :title="'Notify'"
      :visible="configureWhatsappTemplate"
      :isShowFooter="false"
      :containerWidth="'52%'"
      @before-close="configureWhatsappTemplateDialog"
    >
      <WAConfig
        v-loading="emailConfigLoading"
        :element-loading-text="loadingText"
        :currentEntity="currentEntity"
        :isSendIndividual="true"
        :isAutomation="true"
        :keyValue="emailConfigKey"
        :paramsContent="paramsData"
        :allFields="getUserEntities(getFieldsByType(['ENTITY'], allFieldsWithDataTable))"
        v-on:closeNotificationDialog="closeWASendNotificationDialog"
        class="popUp-content"
      ></WAConfig>
    </dialog-component>
  </div>
</template>

<script>
  import StepEditableMixin from './StepEditableMixin';
  import templateBuilderHelper from '../../../../mixins/templateBuilderHelper';
  import { mapGetters } from 'vuex';
  export default {
    name: 'SendWhatsappAction',
    props: {
      step: Object,
      currentEntity: Object,
      companyAllTemplateFields: Object,
      allEntities: Array,
    },
    mixins: [StepEditableMixin, templateBuilderHelper],
    components: {
      WAConfig: () => import('@/components/notifications/WAConfig.vue'),
    },
    data() {
      return {
        emailConfigLoading: false,
        loadingText: 'fetching data...',
        configureWhatsappTemplate: false,
        allFieldsWithDataTable: [],
        emailConfigKey: '',
        paramsData: {},
        whatsapp_object: {},
      };
    },
    computed: {
      ...mapGetters('s3FileUpload', ['getFileUploadData']),
    },
    mounted() {
      this.allFieldsWithDataTable = this.getAllFieldsFromEntity(
        this.currentEntity,
        true,
        true,
        true
      );
    },
    methods: {
      async openWhatsappConfig() {
        this.emailConfigKey = (Math.random() + 1).toString(36).substring(7);
        if (this.localStep?.whatsapp_object) {
          this.paramsData = { ...this.localStep.whatsapp_object };
        } else {
          this.paramsData = {};
        }
        this.configureWhatsappTemplate = true;
      },
      configureWhatsappTemplateDialog() {
        this.configureWhatsappTemplate = false;
      },
      async closeWASendNotificationDialog(data) {
        this.emailConfigLoading = true;
        if (data.attachments && data.attachments?.length) {
          this.loadingText = 'Uploading Files';
          let files = data.attachments.map((e) => {
            return {
              name: e.filename,
              mimetype: e.type,
              data: e.content,
              size: e.size,
            };
          });
          let params = {
            files: files,
            path: 'email-attachments',
          };
          await this.$store.dispatch('s3FileUpload/uploadMultipleBase64Files', params);
          if (this.getFileUploadData && this.getFileUploadData.length) {
            data.attachments = this.getFileUploadData;
          }
        }
        this.loadingText = 'Saving Data';
        this.whatsapp_object = {
          ...data,
        };
        this.configureWhatsappTemplate = false;
        this.emailConfigLoading = false;
        this.$set(this.localStep, 'whatsapp_object', this.whatsapp_object);
      },
    },
  };
</script>
<style scoped>
  .action-config-item {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    font-family:
      'Inter',
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      'Helvetica Neue',
      Arial,
      sans-serif;
    font-size: 13px;
  }

  .email-config-button {
    border-radius: 6px;
    font-weight: 500;
    font-size: 13px;
    padding: 6px 12px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .email-config-button i {
    color: #409eff;
    font-style: normal;
  }

  .popUp-content {
    padding: 1rem;
    background-color: #f9fafb;
    border-radius: 8px;
  }

  /* Dialog adjustments */
  .dialog-component .el-dialog__header {
    font-weight: 600;
    font-size: 14px;
  }

  .dialog-component .el-dialog__body {
    padding: 1rem;
  }

  /* Loading overlay */
  .v-loading-text {
    font-size: 12px !important;
  }

  /* Table / fields inside WAConfig (if any) */
  .el-table th {
    background-color: #f3f4f6;
    font-weight: 600;
    color: #111827;
    font-size: 12px;
  }

  .el-table .el-table__body tr:hover {
    background-color: #f3f4f6;
  }

  .el-select .el-input__inner {
    font-size: 13px;
    border-radius: 6px;
    padding: 0.35rem 0.75rem;
  }

  .el-option:hover {
    background-color: #eff6ff;
  }

  .el-button {
    border-radius: 6px;
    font-weight: 500;
    font-size: 13px;
    padding: 4px 10px;
  }

  .el-button i {
    margin-right: 4px;
  }
</style>
